import { createTheme, ThemeOptions } from '@mui/material/styles';

import { DocumentStatus } from '@/types/document';

import {
  darkBlueGradient,
  forestGradient,
  green,
  neutral,
  orange,
  pink,
  purple,
  red,
  tiberGradient,
  violet,
  yellow,
} from '../constants/colors';
import {
  neutral as caymanNeutral,
  primaries as caymanPrimaries,
} from './colors';

const {
  palette: { augmentColor },
} = createTheme();

export const paletteConfigs: ThemeOptions['palette'] = {
  mode: 'light',
  primary: augmentColor({ color: caymanPrimaries }),
  primary1000: augmentColor({ color: caymanPrimaries, mainShade: 1000 }),
  primary900: augmentColor({ color: caymanPrimaries, mainShade: 900 }),
  primary800: augmentColor({ color: caymanPrimaries, mainShade: 800 }),
  primary500: augmentColor({ color: caymanPrimaries, mainShade: 500 }),
  primary400: augmentColor({ color: caymanPrimaries, mainShade: 400 }),
  primary200: augmentColor({ color: caymanPrimaries, mainShade: 200 }),
  secondary: augmentColor({ color: pink }),
  success: augmentColor({ color: green }),
  error: augmentColor({ color: red }),
  warning: augmentColor({ color: yellow }),
  info: augmentColor({ color: caymanPrimaries }),
  primaries: caymanPrimaries,
  secondaryPink: pink,
  secondaryPurple: purple,
  secondaryViolet: violet,
  yellow: yellow,
  green: green,
  red: red,
  orange: orange,
  grey: neutral,
  violet: violet,
  background: {
    default: neutral.min,
    paper: neutral.min,
  },
  common: {
    white: neutral.min,
    black: neutral.max,
  },
  text: {
    primary: neutral[1000],
    secondary: neutral[700],
    disabled: neutral[700],
  },
  action: {
    disabledBackground: neutral[200],
    disabled: neutral[400],
  },
  badgeBackground: darkBlueGradient,
  status: {
    verified: {
      background: green[100],
      text: green[500],
    },
    unverified: {
      background: orange[100],
      text: orange[600],
    },
    [DocumentStatus.Rejected]: {
      text: red[600],
      background: red[100],
      icon: red[500],
      iconBackground: red[200],
      iconBorder: red[500],
    },
    [DocumentStatus.Approved]: {
      main: green[500],
      background: green[100],
      text: green[500],
      icon: green[500],
      iconBackground: green[200],
    },
    [DocumentStatus.Expired]: {
      main: red[500],
      background: red[500],
      text: neutral.min,
      icon: red[500],
      iconBackground: red[200],
      iconBorder: red[500],
    },
    [DocumentStatus.InReview]: {
      main: yellow[700],
      background: yellow[100],
      text: yellow[700],
      icon: yellow[700],
      iconBackground: yellow[100],
    },
    primary: {
      text: caymanPrimaries[400],
      icon: caymanPrimaries[400],
      iconBackground: caymanPrimaries[100],
    },
    grey: {
      text: neutral[1000],
      icon: neutral[700],
      iconBackground: neutral[100],
    },
  },
  overlay: {
    darkBlue: darkBlueGradient,
    tiber: tiberGradient,
    forest: forestGradient,
  },
  neutral: caymanNeutral,
  semantic: {
    success: green,
    error: red,
    warning: yellow,
    caution: orange,
  },
};
